import { render, staticRenderFns } from "./ExternalText.vue?vue&type=template&id=63ae94f4&"
import script from "./ExternalText.vue?vue&type=script&lang=js&"
export * from "./ExternalText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports